/**
 * Creates a reducer for a fetch action. It sets the initialState as well loading and error.
 * It receives a success function which is supposed to return an object with the wanted state modifications.
 * @param {Object} settings
 * @param {String} settings.FETCH_ACTION - the action name (from types.js)
 * @param {Object} settings.initialState - initial state for the whole reducer
 * @param {Function} settings.success - function to be used for state modifications when fetch was successful
 * @return {Function} The resulting reducer function
 */
const onFetch = () => ({})
const onSuccess = payload => payload

export const objectReducer = (type, initialState = {}, { success = onSuccess, fetch = onFetch, extra } = {}) => (
  state = initialState,
  action
) => {
  switch (action.type) {
    case type:
      return { ...state, loading: true, ...fetch(action.payload, state, action) }
    case type + '_SUCCESS':
      return { ...state, loading: false, loaded: true, error: null, ...success(action.payload, state, action) }
    case type + '_ERROR':
      return { ...state, loading: false, loaded: true, error: action.error || true }
    default:
      return extra ? extra(state, action) : state
  }
}

export const arrayReducer = (type, initialState = [], success = onSuccess) => (state = initialState, action) => {
  return action.type == type + '_SUCCESS' ? success(action.payload, state, action) : state
}

export const cacheable = (condition, type, action) => (...args) =>
  condition(window.store.getState(), ...args) ? { type: `${type}_CACHED` } : { type, ...action(...args) }
